import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FloorMapService } from '../floor-map.service';
import * as XLSX from 'xlsx';
import { FloorMapAddModelComponent } from '../../floor-map-add-model/floor-map-add-model.component';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-import-popup',
  templateUrl: './import-popup.component.html',
  styleUrls: ['./import-popup.component.scss']
})
export class ImportPopupComponent {
  error: string;
  excelFile: any;
  data: any;
  matDialogRef: any;
  selectedFileName: string = '';

  constructor(public dialogRef: MatDialogRef<ImportPopupComponent>, private authService: AuthService,
    private floormapService: FloorMapService, private matDialog: MatDialog,
    private toast: ToastrService
  ) { }

  closePopup() {
    this.dialogRef.close();
  }
  /*-- To get import file --*/
  getExcelFile(evt) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target?.files?.length !== 1) throw new Error('Cannot use multiple files');
    const file = target?.files[0];
    this.selectedFileName = file?.name;   // SHOW FILE NAME
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      console.log(this.data);
    };
    reader.readAsBinaryString(file);
  }

  importFloorsData() {
    var keys = ['mapname', 'map_type', 'region', 'campus', 'building', 'floor', 'address', 'center_lat', 'center_lon', 'scale', 'area', 'south_west_lat', 'south_west_lon', 'north_east_lat', 'north_east_lon'];

    var array = []
    for (let j = 1; j < this.data.length; j++) {
      let map = {};
      for (let i = 0; i < keys.length; i++) {
        map[keys[i]] = this.data[j][i]
      }
      array.push(map)
    }
    let finalObjData = array;
    console.log(finalObjData, '///////////')

    this.matDialogRef = this.matDialog.open(FloorMapAddModelComponent, {
      data: { data: finalObjData, action: 'Import' },
      disableClose: true
    });
    this.dialogRef.close();
    this.matDialogRef.afterClosed().subscribe(res => {
      this.authService.refreshData();
    });
  }
  isEmpty(stringText) {
    if (stringText) {
      if (typeof stringText === 'string') {
        stringText = stringText.trim();
      }
    }
    if (stringText === '' || stringText === undefined || stringText === null || stringText === 'null') {
      return true;
    } else {
      return false;
    }
  }
}
